import { render, staticRenderFns } from "./Splash-Screen.vue?vue&type=template&id=fcc004d8&scoped=true&"
import script from "./Splash-Screen.vue?vue&type=script&lang=js&"
export * from "./Splash-Screen.vue?vue&type=script&lang=js&"
import style0 from "./Splash-Screen.vue?vue&type=style&index=0&id=fcc004d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc004d8",
  null
  
)

export default component.exports